import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-background-50 hover:text-primary-400 transition-colors whitespace-nowrap">
              17c.c
            </Link>
            <p className="mt-3 text-sm text-background-500 leading-relaxed max-w-xs">
              您值得信赖的首选平台，汇聚海量优质内容与资源，满足您的多元需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              获取 17c.c 最新动态与资源更新信息
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-200 text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-200 text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-background-200 text-sm" />
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-600">
            &copy; {new Date().getFullYear()} 17c.c 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-600 hover:text-background-400 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-600 hover:text-background-400 transition-colors whitespace-nowrap">
              使用条款
            </a>
            <a href="#" className="text-xs text-background-600 hover:text-background-400 transition-colors whitespace-nowrap">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}